import React from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { useAuth } from '../../hooks/useAuth';

const AdminLayout = ({ children }) => {
  const { logout, currentUser } = useAuth();
  const navigate = useNavigate();

  const handleLogout = async () => {
    await logout();
    navigate('/auth/login');
  };

  return (
    <div style={{ display: 'flex', minHeight: '100vh' }}>
      <aside style={{ width: '250px', backgroundColor: '#8B0000', color: 'white', padding: '20px' }}>
        <h2>DKL Admin</h2>
        <p>Welcome, {currentUser?.email}</p>
        <nav style={{ marginTop: '40px' }}>
          <Link to="/admin" style={{ display: 'block', color: 'white', margin: '15px 0', textDecoration: 'none' }}>
            Dashboard
          </Link>
          <Link to="/admin/books" style={{ display: 'block', color: 'white', margin: '15px 0', textDecoration: 'none' }}>
            Manage Books
          </Link>
          <Link to="/admin/add-book" style={{ display: 'block', color: 'white', margin: '15px 0', textDecoration: 'none' }}>
            Add New Book
          </Link>
        </nav>
        <button onClick={handleLogout} style={{ marginTop: '50px', background: '#FFD700', color: '#8B0000', border: 'none', padding: '10px', width: '100%' }}>
          Logout
        </button>
      </aside>
      <main style={{ flex: 1, padding: '40px', backgroundColor: '#f9f9f9' }}>
        {children}
      </main>
    </div>
  );
};

export default AdminLayout;